var _path, _circle, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCartOf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shopping-cart-off",
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 19,
    r: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 17a2 2 0 1 0 2 2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 17h-11v-11"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.239 5.231l10.761 .769l-1 7h-2m-4 0h-7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3l18 18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCartOf);
export default __webpack_public_path__ + "static/media/shopping-cart-of.4b3b89c25023fd11c90e79b1a8bec030.svg";
export { ForwardRef as ReactComponent };